import { render, staticRenderFns } from "./project-navbar.vue?vue&type=template&id=41fd5078&"
import script from "./project-navbar.vue?vue&type=script&lang=js&"
export * from "./project-navbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports